import { Component, Input } from '@angular/core';
import { ISlideContent, ISlideData } from '../../interfaces/index';

@Component({
  selector: 'htc-slide-base',
  template: ``,
  standalone: false,
})
export class SlideBaseComponent implements ISlideData {
  type = '';
  contentLoaded = false;
  @Input() id = '';
  @Input() data: ISlideContent = {};

  constructor() {}

  onLoadComplete(): void {
    this.contentLoaded = true;
  }
}
